import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function checkIfContinuityHasConfig
 * @desc 判断连续性案件是否进行配置过
 * @returns {Object}
 */
 const checkIfContinuityHasConfig = () => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/similarity/succession/verifyConfig`
    )
    .then(checkResponse)
}

/**
 * @function getContinuityConfig
 * @desc 获取连续性案件配置
 * @returns {Object}
 */
 const getContinuityConfig = () => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/similarity/succession/getConfig`)
    .then(checkResponse)
}

/**
 * @function postContinuityConfig
 * @desc 提交连续性案件配置
 * @returns {Object}
 */
 const postContinuityConfig = (config) => {
  return axios
    .post(
      `/api/v1/projects/${getProjectId()}/similarity/succession/insertConfig`,
      { config }
    )
    .then(checkResponse)
}

/**
 * @function getContinuityList
 * @desc 获取连续性案件列表
 * @returns {Object}
 */
 const getContinuityList = (time = null) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/similarity/succession/list${
        time ? `?time=${time}` : ''
      }`
    )
    .then(checkResponse)
}

/**
 * @function getContinuityDate
 * @desc 获取连续性案件列表周期
 * @returns {Object}
 */
 const getContinuityDate = () => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/similarity/succession/getConfigTimeList`
    )
    .then(checkResponse)
}

/**
 * @function createContinuityDownload
 * @desc 下载连续性案件
 * @returns {Object}
 */
 const createContinuityDownload = (time) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/similarity/succession/export?${time}`
    )
    .then(checkResponse)
}

export {
  checkIfContinuityHasConfig,
  getContinuityConfig,
  getContinuityDate,
  getContinuityList,
  postContinuityConfig,
  createContinuityDownload
}
